import { writable } from 'svelte/store';
import { GetTime } from 'api/moment'
import { executeClient } from 'api/rage'

window.serverStore = {};

export const serverId = writable(0);
window.serverStore.serverId = (value) => serverId.set (value);

export const serverDonatMultiplier = writable(1);
window.serverStore.serverDonatMultiplier = (value) => serverDonatMultiplier.set (value);

export const serverDonateDoubleConvert = writable(1.5);
window.serverStore.serverDonateDoubleConvert = (value) => serverDonateDoubleConvert.set (value);

export const serverDateTime = writable(new Date().getTime());
export const serverTime = writable(new Date());

setInterval(() => {
    var date = new Date(localDateTime);
    date.setSeconds(new Date().getSeconds());

    serverTime.set(date);
}, 1000);

let localDateTime = "2021-08-17T00:44:10.8644836+03:00";
window.serverStore.serverDateTime = (dateTime) => {
    serverDateTime.set (dateTime);
    localDateTime = dateTime;
    
    const moment = GetTime (dateTime);

    executeClient ("SetTime", moment.hours(), moment.minutes(), moment.unix());
}

window.serverStore.getDateTime = () => {
    return localDateTime;
}

// Онлайн сервера — клиент шлёт его раз в секунду (src_client/player/hud.js).
// Держим в сторе, а не в компоненте: HUD пересоздаётся (рестарт худа, /hudreset),
// и последнее значение должно пережить перемонтирование.
export const serverOnline = writable(0);
window.serverStore.serverOnline = (value) => serverOnline.set (value);

// Серверный ID игрока — тоже в сторе: раньше его перехватывали сразу
// несколько компонентов худа, и последний смонтированный съедал значение.
export const serverPlayerId = writable(0);
window.serverStore.serverPlayerId = (value) => serverPlayerId.set (value);

export const isEvent = writable(false);
window.serverStore.isEvent = (value) => isEvent.set (value);